module.exports = __webpack_public_path__ + "static/media/figma.b971e6c0.png";